





































import { Prop, Component, Vue } from 'vue-property-decorator';
import {
  Button,
  Form,
  FormItem,
  Option,
  Select
} from 'element-ui';
import ModalCard from '@/components/layout/ModalCard.vue';

import FetchOrganizationStaff from '@/graphql/queries/FetchOrganizationStaffs.gql';

import { CustomerFields } from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    members: {
      query: FetchOrganizationStaff,
      variables() {
        return {
          organizationArgs: {
            customerOrganizationId: this.customerOrganization.id
          },
          pagination: {
            page: 1,
            per: 999 // all members
          }
        };
      },
      skip() {
        return !this.customerOrganization;
      },
      update(data) {
        return data?.organizationStaff || [];
      },
      fetchPolicy: 'cache-and-network'
    }
  },
  components: {
    ModalCard,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-option': Option,
    'el-select': Select
  }
})
export default class AssignFollowers extends Vue {
  @Prop({ type: [Object, null] }) customerOrganization!: CustomerFields;
  @Prop({ type: Array }) followers!: string[];
  @Prop({ default: false, type: Boolean }) open!: boolean;

  formInput = {
    followers: this.followers
  };

  members!: CustomerFields[];

  $refs!: {
    followerForm: HTMLFormElement;
  };

  async submit() {
    this.$emit('submit', this.formInput.followers);
  }
}
